export default "__VITE_ASSET__5c96393a__"